export class ShowToast {
    public static readonly type = '[Root state] Show toast';

    constructor(public payload: string) {}
}
